import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-calender-picker',
    standalone: true,
  imports: [CommonModule,TranslatePipe,TranslateModule],
  templateUrl: './calender-picker.component.html',
  styleUrl: './calender-picker.component.scss'
})
export class CalenderPickerComponent {
 @Input() placeholder: string = 'YYYY';
  @Input() initialValue: string = ''; 
  @Input() carInsurance!: boolean;
  @Input() active!: any;
  @Input() showIcon: boolean = true;
  @Output() closeActive= new EventEmitter<any>();
  @Output() dateSelected = new EventEmitter<string>();
  @Output() toggleActive = new EventEmitter<string>();
  showCalendar = false;
  selectedYear: number | null = null;
  yearRangeSize = 24; 
  startYear = 2000;   
  visibleYears: number[] = [];

  ngOnInit() {
    if (this.initialValue) {
      this.selectedYear = parseInt(this.initialValue, 10);
      this.startYear = this.selectedYear - (this.selectedYear % this.yearRangeSize);
    } else {
      const currentYear = new Date().getFullYear();
      this.selectedYear = null;
      this.startYear = currentYear - (currentYear % this.yearRangeSize);
    }
    this.generateVisibleYears();
  }

toggleCalendar() {
     if(this.active !== null){
    this.closeActive.emit(null);
    }
    this.showCalendar = !this.showCalendar;
}

  generateVisibleYears() {
    this.visibleYears = [];
    for (let i = 0; i < this.yearRangeSize; i++) {
      this.visibleYears.push(this.startYear + i);
    }
  }

  changeYearRange(direction: number) {
    this.startYear += this.yearRangeSize * direction;
    this.generateVisibleYears();
  }

  selectYear(year: number) {
    this.selectedYear = year;
    this.dateSelected.emit(year.toString());
    this.showCalendar = false;
  }

   // Listen for clicks on the document to close dropdowns if click is outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.showCalendar = false;
    }
  }


}
